const roiSimulation = {
  pageName: 'Simulação de ROI',
  subtitle:
    'Compare uma execução operacional de referência com uma execução otimizada pelo MoveAI e converta as diferenças em uma história de ROI.',
  controls: {
    title: 'Selecione execuções para comparar',
    grid: 'Grade',
    table: 'Tabela',
    filters: {
      baseline: {
        title: 'Execução de referência',
        description: 'Obtém KPIs para a data selecionada usando o fluxo de trabalho atual do cliente.',
      },
      moveAI: {
        title: 'Execução MoveAI',
        description: 'Obtém KPIs da execução otimizada, gerada pelo MoveAI para a mesma operação.',
      },
      load: 'Carregar',
      loaded: 'Carregado',
    },
  },
  barGraph: {
    title: 'Principais Diferenças (Referência vs MoveAI)',
    kpisSelected: 'KPIs selecionados',
    selectKpis: 'Selecione KPIs para exibir',
    selected: 'selecionados',
  },
  kpiComparisons: {
    title: 'Comparações de KPI',
    resetKpis: 'Redefinir KPIs',
    showDiffAs: 'Mostrar diferença como:',
    absolute: 'Absoluto',
    percentage: '%',
  },
  roiInputs: {
    title: 'Entradas de ROI',
    reset: 'Redefinir',
    perMonth: 'por mês',
    tabs: {
      laborSavings: 'Economia de mão de obra',
      supplierCosts: 'Custos de fornecedores',
      feesHorizon: 'Taxas e horizonte',
    },
    labor: {
      dispatchersToday: 'Despachantes hoje',
      dispatchersTodayTooltip: 'Número de despachantes atualmente empregados.',
      dispatchersWithMoveAI: 'Despachantes com MoveAI',
      dispatchersWithMoveAITooltip: 'Estimativa de despachantes necessários após o MoveAI.',
      costPerDispatcher: 'Custo por despachante',
      hoursPerDay: 'Horas por dia',
      workingDaysPerMonth: 'Dias úteis por mês',
      currency: 'Moeda',
      savingsTitle: 'Economia estimada com despachantes (mensal)',
      savingsDescription: 'Baseado em despachantes reduzidos × custo por hora × horas/dia × dias úteis/mês.',
    },
    supplier: {
      costsToday: 'Custos de fornecedores hoje (mensal)',
      costsWithMoveAI: 'Custos de fornecedores com MoveAI (mensal)',
      savingsTitle: 'Economia com fornecedores (mensal)',
      savingsDescription: 'Custos de fornecedores de referência menos custos de fornecedores do MoveAI.',
      totalSavingsTitle: 'Economia total (mensal)',
      totalSavingsDescription: 'Economia de mão de obra + fornecedores.',
    },
    fees: {
      paymentPlan: 'Plano de pagamento',
      roiHorizon: 'Horizonte de ROI',
      platformMonthlyFee: 'Taxa mensal da plataforma',
      oneTimeImplementationFee: 'Taxa única de implementação',
      avgBookingsPerMonth: 'Média de reservas por mês',
      platformBookingFee: 'Taxa de reserva da plataforma',
      totalCostTitle: 'Custo total (horizonte)',
      totalCostDescription: 'Implementação + (taxas mensais × horizonte).',
      paybackTitle: 'Tempo de retorno',
      paybackDescription: 'Custo total / (economia mensal - taxa mensal).',
      roiTitle: 'ROI',
      roiDescription: 'Benefício líquido no horizonte / custo total.',
      monthlyFee: 'Taxa mensal',
      perBookingFee: 'Taxa por reserva',
    },
    executiveSummary: {
      title: 'Resumo Executivo',
      dispatcherSavings: 'Economia estimada com despachantes (mensal)',
      supplierSavings: 'Economia com fornecedores (mensal)',
      totalSavings: 'Economia total (mensal)',
      totalCost: 'Custo total (horizonte)',
      paybackTime: 'Tempo de retorno',
      roi: 'ROI',
    },
    suffix: {
      hrs: 'hrs',
      days: 'dias',
      day: 'dia',
      hr: '/h',
      months: 'meses',
    },
  },
  roiCardsContainer: {
    kpis: {
      totalReservations: 'Total de Reservas',
      assignedReservations: 'Reservas Atribuídas',
      unassignedReservations: 'Reservas Não Atribuídas',
      sharedRideReservations: 'Reservas Compartilhadas',
      totalTrips: 'Total de Viagens',
      assignedTrips: 'Viagens Atribuídas',
      unassignedTrips: 'Viagens Não Atribuídas',
      sharedRideTrips: 'Viagens Compartilhadas',
      driversWithShifts: 'Motoristas com Turnos',
      assignedDrivers: 'Motoristas Atribuídos',
      avgTripsPerDriver: 'Média de Viagens / Motorista',
      avarageBookingsPerDriver: 'Média de Reservas / Motorista',
      averageTripsDistance: 'Distância Média de Viagem',
      averageTripsDuration: 'Duração Média de Viagem',
      averageDeadheadDistance: 'Média de Percurso Vazio',
      averageIdleTime: 'Tempo Ocioso Médio',
      totalEarnings: 'Ganhos Totais',
      earningPerHour: 'Ganhos por Hora',
      averageTripsEarnings: 'Ganhos Médios por Viagem',
      averageEarningsPerDriver: 'Ganhos Médios / Motorista',
      totalCost: 'Custo Total',
    },
    disabled: 'Desativado',
    baseline: 'Referência',
    moveAI: 'MoveAI',
    noChange: 'Sem Alteração',
    kilometers: 'km',
    minutes: 'min',
    currency: '$',
    k: 'k',
    plus: '+',
    minus: '-',
    percentage: '%',
  },
  tableView: {
    kpiName: 'Nome do KPI',
    diff: 'Dif.',
    exportTable: 'Exportar Tabela',
    kpis: 'KPIs',
    exportedAt: 'Dados exportados em: {{date}}',
  },
  filters: {
    suppliers: {
      title: 'Fornecedor:',
      placeholder: 'Fornecedor',
    },
  },
};

export default roiSimulation;
